import { redactVariables } from '../../services/ai/secretHeuristics';

// Tool definitions live server-side (BackendPheonix.Ai.Tools) for stable prompt caching.

// ── Helpers ────────────────────────────────────────────────────────────────────

/**
 * Redact variable values before they can reach a model provider.
 *
 * The `secret` flag is the user's explicit intent and always wins. The
 * heuristic in services/ai/secretHeuristics.js adds the case the flag misses:
 * a token pasted into an ordinary variable, which defaults to secret:false and
 * would otherwise be transmitted verbatim.
 */
export function maskSecrets(environments) {
  return (environments || []).map((env) => ({
    ...env,
    variables: redactVariables(env.variables),
  }));
}
